import { Component } from "@angular/core";
import { Router } from "@angular/router";
// Models
import { Attachment } from "./../../models/attachment";
// External
import * as lodash from "lodash";
import { PostTypes } from "./../../models/post-types";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { FormsService } from "./../../services/forms";

import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
@Component({
  templateUrl: "./change.password.component.html",
})
export class ChangePasswordComponent {
  public form: FormGroup;

  constructor(
    private router: Router,
    private firebase: FirebaseApp,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase,
    public formsService: FormsService,
    private oAuthService: OAuthService
  ) {}
  ngOnInit() {
    this.form = new FormGroup({
      newPassword: new FormControl("", Validators.required),
      confirmPassword: new FormControl("", Validators.required),
      oldPassword: new FormControl("", Validators.required),
    });
  }
  public submit() {
    this.fireAuth.auth.currentUser
      .updatePassword(this.form.controls["newPassword"].value)
      .then((result) => {
        alert("Password is changed successfully!");
        location.reload();
      })
      .catch((error) => {
        this.fireAuth.auth
          .signInWithEmailAndPassword(
            this.oAuthService.getUser().email,
            this.form.controls["oldPassword"].value
          )
          .then(() => {
            alert("Password is changed successfully!");
            location.reload();
          })
          .catch((error) => {
            alert("Old Password is wrong ,please try again");
            console.error(error);
          });
      });
  }
}
